"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ellipsisWidth = exports.breakText = exports.makeEllipsis = exports.getOffset = exports.secondsToLongTime = exports.sendAnalytic = exports.openWaraucoinChargePage = exports.openTwitterPage = exports.handleFeedbackButtonClick = exports.helpCenterClicked = exports.Utils = void 0;
const phaser_1 = __importDefault(require("phaser"));
const moment_1 = __importDefault(require("moment"));
const GameConst_1 = require("../constants/GameConst");
const TextureKeys_1 = require("../constants/TextureKeys");
const SceneKeys_1 = require("../constants/SceneKeys");
const RegistryKeys_1 = require("../constants/RegistryKeys");
const guide_data_json_1 = __importDefault(require("../assets/guide/guide_data.json"));
const ShopMenuCategoryConfig_1 = require("../containers/shop/ShopMenuCategoryConfig");
const EventConst_1 = require("../constants/EventConst");
class Utils {
    /**
     * Calculate game size according to window size and game ratio
     * @returns {GameSize} size - new game size
     */
    static getGameSize() {
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;
        let gameWidth = winWidth;
        let gameHeight = winHeight;
        if (winWidth >= winHeight) {
            gameWidth = GameConst_1.GAME_RATIO * gameHeight;
        }
        else {
            gameHeight = gameWidth / GameConst_1.GAME_RATIO;
            if (gameHeight > winHeight) {
                gameHeight = winHeight;
                gameWidth = GameConst_1.GAME_RATIO * gameHeight;
            }
        }
        return {
            width: Math.round(gameWidth),
            height: Math.round(gameHeight),
        };
    }
    /**
     * Make a random integer number between min-max
     * @param min minimum number
     * @param max maximum number
     */
    static randomIntBetween(min, max) {
        return Math.round(phaser_1.default.Math.Between(min, max));
    }
    /**
     * [DUMMY] Make a random order
     */
    static randomNewOrder() {
        return {
            id: 10,
            colon: Utils.randomIntBetween(10, 100),
            exp: Utils.randomIntBetween(10, 100),
            delivererId: 1,
            items: [
                {
                    id: 1,
                    amount: Utils.randomIntBetween(1, 10),
                },
                {
                    id: 2,
                    amount: Utils.randomIntBetween(1, 10),
                },
            ],
        };
    }
    /**
     * Add 0-padding to number
     * Ex: (5, 2) => 05, (15, 2) => 15
     * @param num number
     * @param size length of digits
     */
    static padNumber(num, size) {
        let s = num + '';
        if (num < 0) {
            return s;
        }
        while (s.length < size)
            s = '0' + s;
        return s;
    }
    static getTextureGrowthBySeed(seedTexture) {
        switch (seedTexture) {
            case TextureKeys_1.TextureKeys.WheatSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.WheatProduct,
                };
            }
            case TextureKeys_1.TextureKeys.StrawberrySeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.StrawberryProduct,
                };
            }
            case TextureKeys_1.TextureKeys.RadishSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.RadishProduct,
                };
            }
            case TextureKeys_1.TextureKeys.CornSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.CornProduct,
                };
            }
            case TextureKeys_1.TextureKeys.BeanSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.BeanProduct,
                };
            }
            case TextureKeys_1.TextureKeys.CarrotSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.CarrotProduct,
                };
            }
            case TextureKeys_1.TextureKeys.TomatoSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.TomatoProduct,
                };
            }
            case TextureKeys_1.TextureKeys.RiceSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.RiceProduct,
                };
            }
            case TextureKeys_1.TextureKeys.PotatoSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.PotatoProduct,
                };
            }
            case TextureKeys_1.TextureKeys.OliveSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.OliveProduct,
                };
            }
            case TextureKeys_1.TextureKeys.OnionSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.OnionProduct,
                };
            }
            case TextureKeys_1.TextureKeys.CacaoSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.CacaoProduct,
                };
            }
            case TextureKeys_1.TextureKeys.ChickenSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.ChickenProduct,
                };
            }
            case TextureKeys_1.TextureKeys.CowSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.CowProduct,
                };
            }
            case TextureKeys_1.TextureKeys.SheepSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.SheepProduct,
                };
            }
            case TextureKeys_1.TextureKeys.PigSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.PigProduct,
                };
            }
            case TextureKeys_1.TextureKeys.BeeSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.BeeProduct,
                };
            }
            case TextureKeys_1.TextureKeys.XmasSheepSeedItem: {
                return {
                    growth: TextureKeys_1.TextureKeys.XmasSheepProduct,
                };
            }
            default: {
                return {
                    growth: undefined,
                };
            }
        }
    }
    /**
     * Convert sec to hours, minutes , sec
     * @param sec Sec
     */
    static convertTime(_sec) {
        if (_sec <= 0) {
            return '0秒';
        }
        const hours = Math.floor(_sec / 3600);
        const minutes = Math.floor((_sec - hours * 3600) / 60);
        const sec = _sec - hours * 3600 - minutes * 60;
        return ((hours === 0 ? '' : `${hours}時間`) +
            (minutes === 0 ? '' : `${minutes}分`) +
            (sec === 0 ? '' : `${sec}秒`));
    }
    /**
     * Convert seconds to format 'hh : mm : ss'
     * @param timeSecond seconds
     */
    static convertTime2(timeSecond) {
        if (timeSecond <= 0) {
            return '00 : 00 : 00';
        }
        const hours = Math.floor(timeSecond / 3600);
        const hoursString = Utils.padNumber(hours, 2);
        const minutes = Math.floor((timeSecond % 3600) / 60);
        const minutesString = Utils.padNumber(minutes, 2);
        const seconds = timeSecond % 60;
        const secondsString = Utils.padNumber(seconds, 2);
        const timeString = `${hoursString} : ${minutesString} : ${secondsString}`;
        return timeString;
    }
    /**
     * Convert seconds to format '{d}日', '{h}時間', '{m}分', '{s}秒'.
     * Ex: 185s => '3分'.
     * @param timeSecond seconds
     */
    static convertTime3(timeSecond) {
        if (timeSecond <= 0) {
            return '0秒';
        }
        const days = Math.floor(timeSecond / 86400);
        if (days > 0) {
            return `${days}日`;
        }
        const hours = Math.floor((timeSecond % 86400) / 3600);
        if (hours > 0) {
            return `${hours}時間`;
        }
        const minutes = Math.floor((timeSecond % 3600) / 60);
        if (minutes > 0) {
            return `${minutes}分`;
        }
        const seconds = timeSecond % 60;
        return `${seconds}秒`;
    }
    /**
     * get CDN address from meta data of HTML file.
     */
    static getCdnAddress() {
        const metadata = document.querySelector('meta[name="cdn-fqdn"]');
        return metadata['content'];
    }
    /**
     * Parse point data by string to array of number.
     * @param pointData string of point data, ex: "[1, 2, 4, 6, 9, 10]"
     */
    static parsePointMapData(pointData) {
        const regex = /\d+/g;
        const pointArr = pointData.match(regex);
        return pointArr === null || pointArr === void 0 ? void 0 : pointArr.map((x) => +x);
    }
    /**
     * Check capacity in warehouse can add items.
     * @param scene Scene
     * @param amount Amount of item
     */
    static canAddToWarehouse(scene, amount) {
        const layoutScene = scene.scene.get(SceneKeys_1.SceneKeys.Layout);
        const { capacityStatus } = layoutScene.warehouseCapacity;
        return capacityStatus.free - amount >= 0;
    }
    /**
     * get DateString from Date, format input: YYYY/MM/DD HH:mm:ss ZZ
     * @param date
     */
    static getDateString(date, timeZoneFormat) {
        return moment_1.default(date, timeZoneFormat)
            .tz('Asia/Tokyo', true)
            .format(timeZoneFormat);
    }
    /**
     * Get category name of current selected category
     * @param categoryConfig Category item options
     */
    static getCategoryName(categoryConfig) {
        const selectedItem = categoryConfig.find((item) => item.isSelected);
        if (selectedItem.subMenu) {
            const selectedSubItem = selectedItem.subMenu.find((item) => item.isSelected);
            return `${selectedItem.displayName}・${selectedSubItem.displayName}`;
        }
        else {
            return selectedItem.displayName;
        }
    }
    /**
     * Convert categoryID/typeID -> texture/frame
     */
    static convertIdToTexture(categoryId, typeId) {
        let textureKey = null;
        let frameKey = null;
        switch (categoryId) {
            case GameConst_1.ItemCategory.Growth: {
                textureKey = TextureKeys_1.TextureKeys.SubCategory5;
                frameKey = typeId === 4 ? 'crop' : 'animal';
                break;
            }
            case GameConst_1.ItemCategory.Harvest: {
                textureKey = TextureKeys_1.TextureKeys.SubCategory6;
                frameKey = typeId === 6 ? 'crop_product' : 'animal_product';
                break;
            }
            case GameConst_1.ItemCategory.Food: {
                textureKey = TextureKeys_1.TextureKeys.SubCategory7;
                frameKey = Utils.pascalToSnakeCase(GameConst_1.ItemType[typeId]);
                break;
            }
            case GameConst_1.ItemCategory.Craft: {
                textureKey = TextureKeys_1.TextureKeys.CommonCategoryItem;
                frameKey = 'craft';
                break;
            }
            case GameConst_1.ItemCategory.Deco: {
                textureKey = TextureKeys_1.TextureKeys.SubCategory9;
                frameKey = Utils.pascalToSnakeCase(GameConst_1.ItemType[typeId]);
                break;
            }
            case GameConst_1.ItemCategory.Tool: {
                textureKey = TextureKeys_1.TextureKeys.CommonCategoryItem;
                frameKey = 'tool';
                break;
            }
            case GameConst_1.ItemCategory.Nature: {
                textureKey = TextureKeys_1.TextureKeys.CommonCategoryItem;
                frameKey = 'nature';
                break;
            }
            case GameConst_1.ItemCategory.Facility: {
                textureKey = TextureKeys_1.TextureKeys.CommonCategoryItem;
                frameKey = 'facility';
                break;
            }
        }
        return {
            textureKey,
            frameKey,
        };
    }
    /**
     * Increase free of warehouse with integer number
     * It will update warehouse capacity registry
     * @param scene Scene
     * @param increaseNumber integer number to increase free of warehouse
     */
    static increaseFreeWarehouse(scene, increaseNumber) {
        const warehouseCapacityState = scene.registry.get(RegistryKeys_1.RegistryKeys.WarehouseCapacityState);
        warehouseCapacityState.capacityStatus.free += increaseNumber;
        scene.registry.set(RegistryKeys_1.RegistryKeys.WarehouseCapacityState, warehouseCapacityState);
    }
    /**
     * Add event click for game object like image, rect, button, ...
     * Click is 'pointer down then up' action.
     * When 'pointer-down' event is emitted, need to listen 'pointer-up' event
     * on this object and then do action.
     * @param scene Scene
     * @param object game object
     */
    static addClickEventToObject(scene, object) {
        const handlePointerUpInside = (pointer) => {
            object.off('pointerup', handlePointerUpInside);
            object.emit('click', pointer);
        };
        const handlePointerUpOutside = () => {
            scene === null || scene === void 0 ? void 0 : scene.input.off('pointerup', handlePointerUpOutside);
            object.off('pointerup', handlePointerUpInside);
        };
        object.on('pointerdown', () => {
            object.off('pointerup', handlePointerUpInside);
            scene === null || scene === void 0 ? void 0 : scene.input.off('pointerup', handlePointerUpOutside);
            object.on('pointerup', handlePointerUpInside);
            scene === null || scene === void 0 ? void 0 : scene.input.on('pointerup', handlePointerUpOutside);
        });
        object.on('destroy', () => {
            object.off('click');
        });
    }
    /**
     * Generate guide item data for GuideDialog based on category and title name
     */
    static generateGuideData(category, title) {
        const categoryGuide = guide_data_json_1.default.how_to_play.find((item) => item.category === category);
        for (let i = 0; i < categoryGuide.contents.length; i++) {
            const titleGuide = categoryGuide.contents[i];
            if (titleGuide.title === title) {
                return {
                    title: titleGuide.title,
                    pages: titleGuide.pages,
                    imageUrl: categoryGuide.imageFilePath,
                    imageRow: titleGuide.imageRow,
                };
            }
        }
    }
    /**
     * Calculate jewel cost when speed up craft slot
     * @param second Remaining number of seconds
     */
    static calculateJewelCost(second) {
        const remainingMinutes = Math.floor(second / 60);
        const jewelCost = Math.floor(remainingMinutes * 0.2) + 10;
        return jewelCost;
    }
    /**
     * Handler pointer click/tap event
     * Calculate pixel distance between pointerup - pointerdown
     * @param pointer
     * @param pressTime
     */
    static isClicked(pointer, pressTime) {
        if (pressTime >= 1000) {
            return false;
        }
        const deltaX = Math.abs(pointer.downX - pointer.upX);
        const deltaY = Math.abs(pointer.downY - pointer.upY);
        return deltaX <= GameConst_1.CLICK_CLEARANCE_RANGE && deltaY <= GameConst_1.CLICK_CLEARANCE_RANGE;
    }
    /**
     * Select appropriate category when open shop menu
     * @param category category frame
     * @param subCategory subCategory frame
     */
    static selectShopCategory(category, subCategory) {
        ShopMenuCategoryConfig_1.ShopBuyCategoryConfig.forEach((item) => {
            item.isSelected = item.frame === category;
            if (!subCategory || item.frame !== category) {
                return;
            }
            item.subMenu.forEach((subItem) => {
                subItem.isSelected = subItem.frame === subCategory;
            });
        });
    }
    /**
     * Get field type by item category and item type
     * @param itemInfo
     * @returns field type
     */
    static getFieldType(itemInfo) {
        if (itemInfo.categoryId === GameConst_1.ItemCategory.Nature) {
            return GameConst_1.FieldType.Obstacle;
        }
        if (itemInfo.categoryId === GameConst_1.ItemCategory.Deco &&
            itemInfo.typeId === GameConst_1.ItemType.Fence) {
            return GameConst_1.FieldType.Fence;
        }
        if (itemInfo.categoryId === GameConst_1.ItemCategory.Deco &&
            itemInfo.typeId === GameConst_1.ItemType.Ground) {
            return GameConst_1.FieldType.Ground;
        }
        return GameConst_1.FieldType.Normal;
    }
    /*
     * Get shorted text
     * 1234567890 -> 1234... with maxLenght == 4
     * @param text Input text
     * @param maxLenght Max text lenght
     */
    static getShortedText(text, maxLenght) {
        if (text.length <= maxLenght || maxLenght <= 0 || text.length == 0) {
            return text;
        }
        return `${text.substr(0, maxLenght)}...`;
    }
    /**
     * Convert a string in Pascal case to Snake case.
     * For example: 'MyVar' -> 'my_var'
     * @param str the string to convert
     * @returns string in snake case
     */
    static pascalToSnakeCase(str) {
        return str
            .replace(/[A-Z]/g, (val) => '_' + val.toLowerCase())
            .replace(/^_/, '');
    }
    /**
     * Check if the time is still valid
     * @param timeStart time start
     * @param timeEnd  time end
     * @param location place to see time zone
     * @returns boolean true | false
     */
    static isWithinPeriod(timeStart, timeEnd, location) {
        const now = moment_1.default.tz(Date.now(), location);
        const eventStartDate = moment_1.default.tz(timeStart, location);
        const eventEndDate = moment_1.default.tz(timeEnd, location);
        return now.isBefore(eventStartDate) || now.isAfter(eventEndDate);
    }
}
exports.Utils = Utils;
/**
 * Check the sightseeing status of the farm
 * @returns true and userID if the farm is sightseeing, false if the farm is not sightseeing
 */
Utils.isVisited = () => {
    // url visit /game?userId=${USER_ID}
    const url = new URL(window.location.href);
    const paramsUser = url.searchParams.has(GameConst_1.PARAM_SHARE_PROFILE);
    if (!paramsUser) {
        return {
            isVisited: false,
        };
    }
    const userId = url.searchParams.get(GameConst_1.PARAM_SHARE_PROFILE);
    return {
        userId: Number(userId),
        isVisited: userId ? true : false,
    };
};
/**
 * Check if the farm is in tour mode
 * If there is an error in the tour, it will redirect to the main game screen
 */
Utils.isReloadToUrl = () => {
    if (!Utils.isVisited().isVisited) {
        window.location.reload();
        return;
    }
    window.location.href = '/404';
};
Utils.durationFarm = 1000;
Utils.checkDialogExpand = false;
Utils.checkEvenDragHarvest = undefined;
/**
 * Handler when help center button in Q&A is clicked
 */
function helpCenterClicked() {
    // Check user device and open appropriate link
    if (navigator.userAgent.includes('Mobi')) {
        window.open('https://www.warau.jp/sp/help/');
        return;
    }
    window.open('https://www.warau.jp/help/');
}
exports.helpCenterClicked = helpCenterClicked;
/**
 * Handler when feedback button in Q&A is clicked
 */
function handleFeedbackButtonClick() {
    if (navigator.userAgent.includes('Mobi')) {
        window.open('https://www.warau.jp/sp/help/opinion/');
        return;
    }
    window.open('https://www.warau.jp/help/opinion/');
}
exports.handleFeedbackButtonClick = handleFeedbackButtonClick;
/**
 * Open to Twitter page
 */
function openTwitterPage() {
    window.open('https://twitter.com/hugkuma_farm/status/1466336791334559748?s=20', '_blank');
}
exports.openTwitterPage = openTwitterPage;
/*
 * Open charge WarauCoin page
 */
function openWaraucoinChargePage() {
    sendAnalytic({ event: EventConst_1.Events.GAOpenWarau });
    window.open('https://ssl.warau.jp/service/coin/', '_blank');
}
exports.openWaraucoinChargePage = openWaraucoinChargePage;
function sendAnalytic(data) {
    var _a;
    (_a = window) === null || _a === void 0 ? void 0 : _a.dataLayer.push(data);
}
exports.sendAnalytic = sendAnalytic;
/**
 * Convert time in second to hh:mm:ss without space between ':'
 * @param second time to convert
 * @returns time in format hh:mm:ss
 */
function secondsToLongTime(second) {
    return Utils.convertTime2(second).replace(/\s/g, '');
}
exports.secondsToLongTime = secondsToLongTime;
/**
 * Get x, y distance of a container with the scene
 */
function getOffset(container) {
    const { x, y } = container;
    const { parentContainer } = container;
    if (!parentContainer) {
        return { x, y };
    }
    const parentOffset = getOffset(parentContainer);
    return { x: x + parentOffset.x, y: y + parentOffset.y };
}
exports.getOffset = getOffset;
/**
 * Truncate text to specified length-1  and add ellipsis '...'
 */
function makeEllipsis(text, max) {
    return text.length > max ? text.substring(0, --max) + '...' : text;
}
exports.makeEllipsis = makeEllipsis;
/**
 * Break a into multiple lines if its width reachs the breakWidth
 */
function breakText(options) {
    const newValue = [];
    const textObject = new phaser_1.default.GameObjects.Text(options.scene, 0, 0, '', options.textStyle);
    options.text.split('').forEach((char) => {
        // concat character one by one
        // and calculate the width after concatatenation
        newValue.push(char);
        textObject.setText(newValue.join(''));
        textObject.width > options.breakWidth && newValue.splice(-1, 0, '\n');
    });
    return newValue.join('').split('\n');
}
exports.breakText = breakText;
/**
 * Add ellipsis if a string longer than the specified maxWidth
 */
function ellipsisWidth(options) {
    const sampleText = new phaser_1.default.GameObjects.Text(options.scene, 0, 0, '', options.textStyle);
    let result = options.text.replace(/.$/, '...');
    let subEnd = options.text.length - 1;
    let strWidth = sampleText.setText(result).width;
    while (strWidth > options.maxWidth) {
        result = options.text.substring(0, --subEnd) + '...';
        strWidth = sampleText.setText(result).width;
    }
    return result;
}
exports.ellipsisWidth = ellipsisWidth;
